export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recherche"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vous êtes en mode Démo. Les soldes et les opérations sont d'entraînement."])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accéder au cabinet de travail"])}
}